import React from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";
import Rocket from "images/login-page-rocket.png";
import Buildings from "images/login-page-buildings.png";

const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  background-color: #6ad7c4;
`;

const TopContainer = styled.div`
  display: flex;
  flex: 3;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

const RocketContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const RocketImageContainer = styled.div`
  width: 65%;
`;
const RocketImage = styled.img`
  width: 100%;
  height: auto;
`;

const TitleContainer = styled.div`
  margin-top: 32px;
`;

const Title = styled.div`
  font-size: 20px;
  text-align: center;
  color: white;
  opacity: 0.85;
`;

const BottomContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  opacity: 0.85;
`;

const BuildingsImage = styled.div`
  flex: 1;
  background-size: auto 100%;
  background-image: url(${Buildings});
  background-position: center center;
`;

function RocketLayout() {
  const { formatMessage } = useIntl();

  return (
    <Container>
      <TopContainer>
        <RocketContainer>
          <RocketImageContainer>
            <RocketImage src={Rocket} alt="Rocket" />
          </RocketImageContainer>
        </RocketContainer>

        <TitleContainer>
          <Title>
            {formatMessage({ id: "loginScene.rocket.firstPartTitle" })}
          </Title>
          <Title>
            {formatMessage({ id: "loginScene.rocket.secondPartTitle" })}
          </Title>
        </TitleContainer>
      </TopContainer>

      <BottomContainer>
        <BuildingsImage />
      </BottomContainer>
    </Container>
  );
}

export default RocketLayout;
